/**
 * Queue allocation statuses: which node-instance statuses count toward the
 * queue concurrency limit. `dispatched` is not shown in the UI — it stays in
 * lockstep with `started` (agent handoff).
 */

export const DEFAULT_QUEUE_ALLOCATION_STATUSES = ['running', 'started', 'dispatched', 'WorkflowWait', 'killing'] as const;

/** User-facing Allocation Status checkboxes — `dispatched` follows `started`. */
export const QUEUE_ALLOCATION_STATUS_OPTIONS = ['running', 'started', 'WorkflowWait', 'killing'] as const;

/**
 * Toggle a user-facing allocation status while keeping hidden `dispatched`
 * synchronized with `started`.
 */
export function toggleQueueAllocationStatus(current: string[] | null | undefined, status: string, checked: boolean): string[] {
  const list = Array.isArray(current) ? current : [];
  let updated = checked ? Array.from(new Set([...list, status])) : list.filter((s) => s !== status);

  // `started` owns the agent handoff: keep hidden `dispatched` in lockstep.
  if (status === 'started') {
    updated = checked
      ? Array.from(new Set([...updated.filter((s) => s !== 'dispatched'), 'started', 'dispatched']))
      : updated.filter((s) => s !== 'dispatched' && s !== 'started');
  } else {
    if (updated.includes('started') && !updated.includes('dispatched')) {
      updated = [...updated, 'dispatched'];
    }
    if (!updated.includes('started')) {
      updated = updated.filter((s) => s !== 'dispatched');
    }
  }

  return updated;
}
